import {DrawerProps} from '@mantine/core';
import {PlatformDrawer} from '@flexinet/ui-components';
import {RecordForm} from '../forms/RecordForm';
import config from '../config';
import {UserRecordFormProps} from '../types';

// The drawer AWAITS the save and closes only when it succeeds. The console's
// copy closed straight after starting it, so a refused save closed the drawer
// and threw the person's edits away. A failure has already been announced by
// the mutation's notifyError; the drawer stays open so they can fix and retry.
export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & Omit<UserRecordFormProps, 'handleCancel'>) => {

    const title = record.id
        ? `Edit ${config.titles.singular}`
        : `New ${config.titles.singular}`;

    const submitAndClose = async (values: Parameters<typeof handleSubmit>[0]) => {
        try {
            await handleSubmit(values);
            onClose();
        } catch {
            // Already reported to the person; keep the form and its values open.
        }
    };

    return (
        <PlatformDrawer opened={opened} onClose={onClose} title={title} {...rest}>
            <RecordForm record={record} handleSubmit={submitAndClose} handleCancel={onClose}/>
        </PlatformDrawer>
    );
};
